/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AccessRequestAppExternalConnection } from './AccessRequestAppExternalConnection';
import {
    AccessRequestAppExternalConnectionFromJSON,
    AccessRequestAppExternalConnectionFromJSONTyped,
    AccessRequestAppExternalConnectionToJSON,
} from './AccessRequestAppExternalConnection';

/**
 * 
 * @export
 * @interface AccessRequestsAppAccessRule
 */
export interface AccessRequestsAppAccessRule {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsAppAccessRule
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsAppAccessRule
     */
    organization_id: string;
    /**
     * Person ID
     * @type {string}
     * @memberof AccessRequestsAppAccessRule
     */
    person_id: string;
    /**
     * 
     * @type {AccessRequestAppExternalConnection}
     * @memberof AccessRequestsAppAccessRule
     */
    app_external_connection: AccessRequestAppExternalConnection;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsAppAccessRule
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsAppAccessRule
     */
    app_url?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsAppAccessRule
     */
    identifier_from_source: string;
    /**
     * 
     * @type {Date}
     * @memberof AccessRequestsAppAccessRule
     */
    created_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AccessRequestsAppAccessRule
     */
    last_updated_at?: Date;
}

/**
 * Check if a given object implements the AccessRequestsAppAccessRule interface.
 */
export function instanceOfAccessRequestsAppAccessRule(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "organization_id" in value;
    isInstance = isInstance && "person_id" in value;
    isInstance = isInstance && "app_external_connection" in value;
    isInstance = isInstance && "identifier_from_source" in value;

    return isInstance;
}

export function AccessRequestsAppAccessRuleFromJSON(json: any): AccessRequestsAppAccessRule {
    return AccessRequestsAppAccessRuleFromJSONTyped(json, false);
}

export function AccessRequestsAppAccessRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRequestsAppAccessRule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organization_id': json['organization_id'],
        'person_id': json['person_id'],
        'app_external_connection': AccessRequestAppExternalConnectionFromJSON(json['app_external_connection']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'app_url': !exists(json, 'app_url') ? undefined : json['app_url'],
        'identifier_from_source': json['identifier_from_source'],
        'created_at': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'last_updated_at': !exists(json, 'last_updated_at') ? undefined : (new Date(json['last_updated_at'])),
    };
}

export function AccessRequestsAppAccessRuleToJSON(value?: AccessRequestsAppAccessRule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'organization_id': value.organization_id,
        'person_id': value.person_id,
        'app_external_connection': AccessRequestAppExternalConnectionToJSON(value.app_external_connection),
        'description': value.description,
        'app_url': value.app_url,
        'identifier_from_source': value.identifier_from_source,
        'created_at': value.created_at === undefined ? undefined : (value.created_at.toISOString()),
        'last_updated_at': value.last_updated_at === undefined ? undefined : (value.last_updated_at.toISOString()),
    };
}

